
import { Howl, Howler } from 'howler';
import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
import { Draggable	 } from 'gsap/Draggable';
gsap.registerPlugin(Draggable);

import ticker from 'ticker';

/*
class HowlerControl extends Howler{
    constructor() {
        super();
        this.sounds_ids = [];
    }
    static set soundIds( sound_id ) {
        this.sounds_ids.push( sound_id );
    }
    static get soundIds(){
    	return this.sounds_ids
    }
}
const  howlerControl = new HowlerControl();
*/

// Can't find a better way yet!!!
Howler.audios = [];
Howler.registerAudio =  function( audio, b ){
	if ( b ){
		this.audios.push( audio );
	}
	else{
		let i = this.audios.length, _audio;
		while( i-- ){
			_audio = this.audios[ i ];
			if ( audio.getSoundId() === _audio.getSoundId() ){
				this.audios.splice( i, 1 );
				return;
			}
		}		
	}
}
Howler.pauseOtherSoundsPlaying =  function( sound_id ){
	let i = this.audios.length, audio;
	while( i-- ){
		audio = this.audios[ i ];
		if ( audio.getSoundId() !== sound_id ){
			audio.pauseIfPlaying( sound_id );
		}
	}
}

export default class{

    constructor(options) {
        this.defaults = {
        	$el: false,
        	src: false,

        	loop: false,
        	html5: false,
        	default_volume: 0.7,

        	update: true,
            interval_event_time: 10*1000
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = 'audioplayer';

		this.$el = this.options.$el;


		if ( this.$el ){
			this.init();
		}
		else{
			if ( this.options.src === '' ){
				this.log( 'You must pass an audio file to the audioPlayer constructor' );
			}
			else{
				this.log( 'You must pass the dom element to the audioPlayer constructor' );
			}
		}
    }

    init(){

        //this.log( 'init' );

		this.$play  	= 	this.$el.find( '.play' );
		this.$pause 	=  	this.$el.find( '.pause' );
		this.$text 		=   this.$el.find( '.text' );
        this.$range     =   this.$el.find( '.range' );
        this.$cursor    =   this.$el.find( '.cursor' );
        this.w_cursor   =   this.$cursor.width();
        this.$indicator =   this.$el.find( '.indicator' );

        this.src = undefined;
        this.$btn = [];

        this._reset();

        this.addPlayerEvents(true);

        if ( this.options.src ){
            this.playSound(  this.options.src );
        }
    }

    playSound( src, info ){

        this.closeSound();

        this.setText( info.title, info.author );

        this.$btn  = info.$btn;
        // we force the play state while loading to avoid clicking on play more times
        this.onSoundEvenAdditionalActions( 'play' );

        // init sound with HOWL
        this.sound = new Howl({
            src:    src,
            autoplay: true,
            loop:   this.options.loop,
            html5:  this.options.html5,
            volume: this.options.default_volume
        });
        // Change global volume.
        // Howler.volume( this.options.default_volume );
        this.initRange( true );
        this.addSoundEvents( true );
        this.openPlayer( true );

        this.info = {
            src: src,
            title: info.title
        }
    }

    closeSound(){
        
        this.activateGaEvent( false );

        if ( this.sound ){

            this.onSoundEvenAdditionalActions( 'unload' );

            this.$btn = [];

            this.activateTick( false );
            this.initRange( false );
            this.addSoundEvents( false );
            // Howler.registerAudio( this, false );
            // this.sound.stop();
            this.sound.unload();
            this.sound = null;

            this.initTickers( false )

        } 
    }

    onSoundEvenAdditionalActions( event ){       
        if ( this.$btn.length > 0 ){
            if ( event === 'play' ){
                this.$btn.addClass( 'is-playing' );
            }
            else{
                this.$btn.removeClass( 'is-playing' );
            }
        }
    }

    openPlayer( b ){
        if ( b === this.$el.hasClass( 'open' ) ){
            return;
        }
        if ( b ){
            this.$el.addClass( 'open' );
        }
        else{
            this.$el.removeClass( 'open' );
            
            this.closeSound();
            this.$el.removeClass( 'sound-loaded' );
            this.$play.removeClass( 'hidden' );
            this.$pause.addClass( 'hidden' );

            this.options.main.setGAEvent( 'Audio Close', 'click', this.info.title, this.info.src );

        }
    }

    _reset(){
        this.setText();
        this.setTime();
    }

    initRange( b ){
    	let $c = this.$cursor;
    	if ( $c.length > 0 ){
    		if ( b ){
    			this.draggable = Draggable.create( $c, {
    				bounds: this.$range,
    				lockAxis: 'x',
    				type: 'x',
    				onDragStart: 	() => this.onDrag( 'start' ),
    				onDrag: 		() => this.onDrag( 'drag' ),
    				onDragEnd: 		() => this.onDrag( 'end' )
    			});
    			this.dragging = false;
    			this.range_length = this.$range.width();
    			this.$range.on( 'click', (e) => this.onClickRange(e) );
    		}
 			else{
 				this.$range.off( 'click', (e) => this.onClickRange(e) );
 			}
    	}
    }

    //---------------------------------------- EVENTS ---------------------------------------//
    addSoundEvents(b){
    	if ( b ){
    		 //--------- SOUND EVENTS
    		this.sound.on( 'load',						()=>this.onSound( 'load' ));
    		this.sound.on( 'play', 						()=>this.onSound( 'play' ));
    		this.sound.on( 'pause', 					()=>this.onSound( 'pause' ));
    		this.sound.on( 'end', 						()=>this.onSound( 'end' ));
    		this.sound.on( 'stop', 						()=>this.onSound( 'stop' ));

    	}
		else{
			 //--------- SOUND EVENTS
    		this.sound.off( 'load', 					()=>this.onSound( 'load' ))			
    		this.sound.off( 'play', 					()=>this.onSound( 'play' ));
    		this.sound.off( 'pause', 					()=>this.onSound( 'pause' ));
    		this.sound.off( 'end', 						()=>this.onSound( 'end' ));
    		this.sound.off( 'stop', 					()=>this.onSound( 'stop' ));

		}
			
    }

    addPlayerEvents(b){
        if ( b ){
            this.$el.find( '.close' ).on( 'click', ()=>{this.openPlayer(false)} );
            //--------- BUTTONS (CONTROLS) EVENTS
            this.$play.on( 'click',     ()=>this.onButton( 'play' ));
            this.$pause.on( 'click',    ()=>this.onButton( 'pause' ));
        }
        else{
            this.$el.find( '.close' ).off( 'click', ()=>{this.openPlayer(false)} );
            //--------- BUTTONS (CONTROLS) EVENTS
            this.$play.off( 'click',    ()=>this.onButton( 'play' ));
            this.$pause.off( 'click',   ()=>this.onButton( 'pause' ));
        }
        this.debounceResize(b);
    }

    debounceResize(b){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 17 );
			$(window).on( 'resize', this._debResize );
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				$(window).off( 'resize', this._debResize );
			}        
		}
    }

    onResize(){
    	this.range_length = this.$range.width();
    	this.update()
    }

    //--------- SOUND EVENTS
    onSound( event ){
    	switch( event ){
    		case 'load':
		    	this.duration = this.sound.duration();
		    	this.updateTime( 0 );
		    	this.$el.addClass( 'sound-loaded' );
    		break;
    		case 'play':
    			this.$el.addClass( 'is-play' );
    			this.$play.addClass( 'hidden' );
    			this.$pause.removeClass( 'hidden' );

    			this.activateTick( true );
                this.activateGaEvent( true );
    		break;
    		case 'pause':
    			this.$el.addClass( 'is-pause' );
    			this.$play.removeClass( 'hidden' );
    			this.$pause.addClass( 'hidden' );

    			this.activateTick( false );
                this.activateGaEvent( false );
    		break;
    		case 'end':
    			this.onSound( 'pause' );
    			this.updateRange( 0 );
    			this.updateTime( 0 );
    		break;
    		case 'stop':
    			this.onSound( 'pause' );
    			this.updateRange( 0 );
    			this.updateTime( 0 );
    		break;
    	}
        this.onSoundEvenAdditionalActions( event );
    }

    activateGaEvent( b ){
        if ( b ){
            this.interval_event = setInterval( ()=>this.sendEvent(), this.options.interval_event_time );
        }
        else{
            clearInterval( this.interval_event );
        }
    }

    sendEvent(){
        this.options.main.setGAEvent( 'Audio Play 10s Interval', 'interval', this.info.title, this.info.src );
    }

    //--------- BUTTONS (CONTROLS) EVENTS
    onButton( state ){
    	switch (state){
    		case 'play':
    			this.play(true);
    		break; 
    		case 'pause':
    			this.play(false);
    		break;
    	}
    }

    onDrag( state ){
    	//let x = gsap.getProperty( this.$cursor[0], 'x' ), s;
    	switch ( state ){
    		case 'start':
    			this.dragging = true;
    			if ( !this.sound.playing( this.sound_id ) ){
    				this.play(true);
    			}
                else{
                    this.play(false);
                    this.play(true);
                }
    		break;
    		case 'drag':
    			//s = this.duration*x/this.range_length
    			//this.sound.seek( s, this.sound_id );
    		break;
    		case 'end':
    			this.dragging = false;
    		break;
    	}
    	//this.updateIndicator( x );
    }

    onClickRange(e){
    	if ( $(e.target).hasClass( 'bg' ) ){
    		let x = e.originalEvent.offsetX;
    		gsap.to( this.$cursor, {
    			x : x,
    			ease: 'power.easeOut',
    			duration: 0.2,
    			onStart: () => this.onDrag( 'start' ),
    			onComplete: () => this.onDrag( 'end' )
    		})
    	}
    }

    //---------------------------------------- TICKER UPADTES --------------------------------//
    activateTick(b){
    	if ( !this.options.update ){
    		return;
    	}

        this.active = false;
        if ( this.id_ticker ){
            cancelAnimationFrame( this.id_ticker );
        }
		if ( b ){
			this.active = true;
			this.tick();
		}
        this.activateTickers( b )
    }

    tick(){
		this.update();
		if ( this.active ){
			this.id_ticker = requestAnimationFrame( () => this.tick() );
		}
	}

    update(){
        if ( this.sound ){
        	let c 	= this.sound.seek( this.sound_id ), x, seek;

        	// update time always
        	this.updateTime( c );

        	if ( this.dragging ){

        		x 		= gsap.getProperty( this.$cursor[0], 'x' );
       			seek 	= this.duration*x/this.range_length;

       			// seek sound while dragging
        		this.sound.seek( seek, this.sound_id );

        		// update indicators
    			this.updateIndicator( x + this.w_cursor );    		
        	}
        	else{

        		x = this.range_length*c/this.duration;

        		// update all range
        		this.updateRange( x );
        	}
        }
    }

    updateIndicator( x ){
    	gsap.set( this.$indicator, {x: - this.range_length + x } );
    }

    updateRange( x ){
    	// update cursor
    	gsap.set( this.$cursor, {x: x - this.w_cursor/2 } );
    	// update indicator
    	this.updateIndicator( x );
    }

    updateTime( c ){
    	let t = this.formatToMinSec( c );
    	this.setTime( t );
    }


    //---------------------------------------- UTILS -----------------------------------------//
    format2( n ){
      	return n < 10 ? '0' + n : n;
    }

    formatToMinSec( p ){
      	let m = parseInt(p/ 60, 10),
    	s = parseInt(p % 60);
      	return  m + ':' + this.format2( s );
    }
    setText( title, author ){
        let $l =  this.$el.find( '.display .breakpoint-large' ), $m = this.$el.find( '.display .breakpoint-small' ), 
            t = title ? title : '', 
            a = author ? '' + author : '';


        this.initTickers( false );


        $l.find( '.title' ).html( t );
        $l.find( '.author' ).html( a );
        $m.find( '.title' ).html( t + '<span class="author sidebar-text text-gray">, ' +  a + '</span>' );

        if ( t !== '' ){
             this.initTickers( true );
        }
       

    }
    setTime( t ){
        this.$text.html( t?t:'' );
    }

    initTickers( b ){
        let $l =  this.$el.find( '.display .breakpoint-large' ), $m = this.$el.find( '.display .breakpoint-small' );
        if ( b ){
            this.ticker_l = new ticker( {
                $el: $l.find('.ticker')
            });
            this.ticker_m = new ticker( {
                $el: $m.find('.ticker')
            });
        }
        else{
            if ( this.ticker_l ){
                this.ticker_l.destroy();
                this.ticker_l = null
            }
            if ( this.ticker_m ){
                this.ticker_m.destroy();
                this.ticker_m = null
            }
        }
    }

    activateTickers(b){
        if ( this.ticker_l ){
            this.ticker_l.play(b)
        }
        if ( this.ticker_m ){
            this.ticker_m.play(b)
        }        
    }

    //---------------------------------------- METHODS ---------------------------------------//
    play(b){
    	if ( b ){
    		if ( !this.sound_id ){
    			this.sound_id = this.sound.play();
    			Howler.registerAudio( this, true );
    		}
    		else{
    			this.sound.play(this.sound_id);
    		}
    		// stop all other sounds if playing
    		Howler.pauseOtherSoundsPlaying( this.sound_id );
    		// stop all sounds
    		// Howler.stop();
    	}
    	else{
    		this.sound.pause(this.sound_id)
    	}
    }

    getSoundId(){
    	return this.sound_id;
    }

    // if you have more then one audio_player, call this tpo pause the player
    pauseIfPlaying( sound_id ){
		if ( this.sound_id ){
			if ( this.sound_id !== sound_id && this.sound.playing( this.sound_id ) ){
				this.play( false );
			}
		}
    }

    log( str ){
        console.log(  this.namespace + ' :: ' + str );
    }

    destroy(){
        this.log( 'DESTROY ' );
        this.initTickers( false );
    	this.activateTick( false );
    	this.initRange( false );
    	this.addSoundEvents( false );
        this.addPlayerEvents( false );
    	Howler.registerAudio( this, false );
    	this.sound.stop();
    	this.sound.unload();
    }

}